import styled from 'styled-components'

export const ScrollableContainer = styled.div`
  // 72px is sum of static elements heights that should not scroll
  height: ${p => `calc(100vh - ${p.$mobileMenuOffset}px - 72px)`};
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`
